import React from 'react';
import { ReactComponent as CustomProductListTileIcon } from 'qs-assets/Media/ic_product_list_tile_icon.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <CustomProductListTileIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
